<template>
  <v-btn v-bind="$attrs" :value="value" v-on="$listeners" :small="small">
    <v-icon left :small="small" color="delete">delete_forever</v-icon>
    <slot>
      {{text}}
    </slot>
  </v-btn>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: '',
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      text() {
        return this.label == '' ? 'Delete' : this.label
      },
    },
  }
</script>